import React, { AnchorHTMLAttributes, FC } from 'react'

import { PropsWithClassName } from '@smarty-nx/data'
import cn from 'classnames'

import { footerItems } from './dashboard-footer.content'
import classes from './dashboard-footer.module.scss'
import { FooterItem } from './dashboard-footer.types'
import IosAppImage from '../../assets/images/app-icons/app-store.svg'
import GoogleAppImage from '../../assets/images/app-icons/google-play-store.svg'

const Item: FC<
  AnchorHTMLAttributes<HTMLAnchorElement> & {
    dataTestId?: string
  }
> = ({ children, dataTestId, ...props }) => (
  <li className={classes.listItem}>
    <a data-testid={dataTestId} {...props}>
      {children}
    </a>
  </li>
)

export const DashboardFooter: FC<
  PropsWithClassName<{ marketingUrl?: string }>
> = ({ className, marketingUrl = '' }) => {
  const togglePreferenceCenter = () => {
    if (window.OneTrust) {
      window.OneTrust.ToggleInfoDisplay()
    }
  }

  return (
    <ul className={cn(classes.list, className)} data-testid="footer-container">
      {footerItems(marketingUrl).map((footerItem: FooterItem) => {
        if (footerItem.dataTestId === 'footer-cookie-preferences') {
          return (
            <Item key={footerItem.title}>
              <button
                className={classes.otSettingsButton}
                data-testid={footerItem.dataTestId}
                onClick={togglePreferenceCenter}
              >
                {footerItem.title}
              </button>
            </Item>
          )
        }
        return (
          <Item
            key={footerItem.title}
            href={footerItem.href || ''}
            dataTestId={footerItem.dataTestId}
          >
            {footerItem.title}
          </Item>
        )
      })}
      <Item
        href="https://apps.apple.com/app/apple-store/id1540812668?pt=421745&mt=8&ct=smarty_web_download"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="iOS App"
      >
        <img
          className={classes.iosApp}
          src={IosAppImage}
          alt="IOS App"
          data-testid="ios-app"
        />
      </Item>
      <Item
        href="https://play.google.com/store/apps/details?id=com.hutchison3g.sundae&referrer=utm_source%3Dsmarty%26utm_medium%3Dweb%26utm_content%3Dappstore_logo"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Google play store app"
      >
        <img
          className={classes.googleApp}
          src={GoogleAppImage}
          alt="Google Play Store App"
          data-testid="google-app"
        />
      </Item>
    </ul>
  )
}
